import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Box,
} from "@mui/material";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import useVersionCheck from "../hooks/useVersionCheck";

const VersionUpdateDialog = () => {
  const { updateAvailable, newVersion, currentVersion, reload } =
    useVersionCheck();

  const handleClose = (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
  };

  return (
    <Dialog
      open={updateAvailable}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgb(0,0,0,0.45)",
        },
        "& .MuiDialog-paper": {
          borderRadius: "4px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#9BCD65",
          color: "#000",
          textAlign: "center",
          fontWeight: 700,
          fontSize: "18px",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          letterSpacing: "0.05rem",
          py: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <SystemUpdateAltIcon sx={{ fontSize: 28 }} />
          Nueva versión disponible
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ textAlign: "center", py: 3, px: 3 }}>
        <Typography
          sx={{
            fontSize: "16px",
            color: "#333",
            mb: 2,
            lineHeight: 1.6,
          }}
        >
          Hay una nueva versión del portal disponible.
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#666", mb: 0.5 }}>
          Versión actual: <strong>{currentVersion}</strong>
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#666", mb: 2 }}>
          Nueva versión: <strong>{newVersion}</strong>
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#888", lineHeight: 1.6 }}>
          Presione <strong>Actualizar</strong> para cargar la última versión.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3, px: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={reload}
          sx={{
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontWeight: 600,
            fontSize: "14px",
            px: 4,
            py: 1,
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#8bb85a",
              boxShadow: "none",
            },
          }}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionUpdateDialog;
